import React from 'react'

export default function ExperienceIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 64 64"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M55 45.006V41a5.006 5.006 0 00-5-5h-8.418a28.187 28.187 0 002.228-5.367l3.8-3.041a3.694 3.694 0 00-2.188-6.579l2.228-6.126A10.35 10.35 0 0037.924 1h-8.49A33.865 33.865 0 0011.47 6.152a1 1 0 00.214 1.8l2.411.8a2.568 2.568 0 011.572 3.389 4.568 4.568 0 00.155 3.739l2.578 5.151a3.689 3.689 0 00-2.008 6.561l3.8 3.041A28.187 28.187 0 0022.418 36H14a5.006 5.006 0 00-5 5v4.006A13.018 13.018 0 001 57v5a1 1 0 001 1h60a1 1 0 001-1v-5a13.018 13.018 0 00-8-11.994zM40 21h-6a1 1 0 00-1 1v1h-2v-1a1 1 0 00-1-1h-9v-1.465l6.242-4.161A8.155 8.155 0 0131.78 14a10.212 10.212 0 006.359-2.231l1.634-1.307 1.715 2.574A8.969 8.969 0 0143 18.028V21zm-1 2v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3zm-10 0v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3zm18 1.7a1.694 1.694 0 01-.638 1.328l-1.813 1.45A28.141 28.141 0 0044.984 23h.316a1.7 1.7 0 011.7 1.7zM17.523 12.884a4.568 4.568 0 00-2.795-6.029l-.306-.1A31.863 31.863 0 0129.434 3h8.49a8.35 8.35 0 017.847 11.2l-.869 2.39a10.966 10.966 0 00-1.75-4.668l-2.32-3.481a1 1 0 00-.679-.433 1.01 1.01 0 00-.778.207l-2.485 1.993A8.215 8.215 0 0131.78 12a10.152 10.152 0 00-5.648 1.71l-6.687 4.458a.992.992 0 00-.17.146l-1.664-3.329a2.567 2.567 0 01-.088-2.101zm.116 13.146A1.7 1.7 0 0118.7 23h.314a28.141 28.141 0 00.435 4.48zM21.016 23H23v3a3 3 0 003 3h2a3 3 0 003-3v-1h2v1a3 3 0 003 3h2a3 3 0 003-3v-3h1.984a26.183 26.183 0 01-3.711 13H24.727a26.183 26.183 0 01-3.711-13zM14 38h36a3 3 0 013 3v20H11V41a3 3 0 013-3zM3 57a11.016 11.016 0 016-9.793V61H3zm58 4h-6V47.207A11.017 11.017 0 0161 57z"
                data-original="#000000"
               
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M32 58a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2zM25.293 48.707l1.414-1.414L23.414 44l3.293-3.293-1.414-1.414-4 4a1 1 0 000 1.414zM38.707 48.707l4-4a1 1 0 000-1.414l-4-4-1.414 1.414L40.586 44l-3.293 3.293z"
                data-original="#000000"
               
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M27 43H37V45H27z"
                data-original="#000000"
                transform="rotate(-53.119 32 44)"
                
            ></path>
        </svg>
    )
}
